var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoaded)?_c(_vm.layout,{tag:"component"}):_c('div',{staticClass:"flex justify-center items-center h-screen"},[_c('div',{staticClass:"svg-custom",domProps:{"innerHTML":_vm._s(_vm.svgText)}})])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }